import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ExpandMore from '@mui/icons-material/ExpandMore';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import { getDataCenterLocations } from '../utils/helpers';

const DataCenter = ({ showLabel = false, defaultValue = '', ...props }) => {
  const { t } = useTranslation('addSites');
  const { setValue, watch } = useFormContext();

  const dataCenterLocations = getDataCenterLocations();

  const value = watch('datacenter', defaultValue);

  return (
    <Autocomplete
      id="data-center-location"
      autoHighlight
      openOnFocus
      data-testid="data-center-location-dropdown"
      value={value}
      onChange={(e, newValue) => setValue('datacenter', newValue)}
      options={dataCenterLocations}
      popupIcon={<ExpandMore />}
      renderInput={(params) => (
        <TextField
          {...params}
          {...(showLabel && {
            label: t('siteTitle.dataCenterLocationLabel'),
          })}
        />
      )}
      {...props}
    />
  );
};

export default DataCenter;
